<template>
    <div class="ujian-page">
        <div class="container-fluid mt-1">
            <div class="row">
                <div class="col-xl-8 mb-5 mb-xl-0">
                    <card header-classes="bg-transparent" body-classes="bg-transparent p-0">
                        <div slot="header" class="row align-items-center">
                            <div class="col-lg-6">
                                <h6 class="text-uppercase ls-1 mb-1">{{detailUjian.name}}</h6>
                                <sup>{{detailUjian.created}}</sup>
                            </div>
                            <div class="col-lg-6" style="font-size: 14px;">
                                <span :class="detailUjian.color">{{detailUjian.label}}</span>
                            </div>
                        </div>
                        <div class="card-body row">
                            <div class="col-lg-6">
                                <div class="row">
                                    <div class="col-lg-8 d-flex justify-content-between">
                                        <div> <strong>Bentuk Pengerjaan</strong></div>
                                        <span>:</span>
                                    </div>
                                    <div class="col-lg-4 d-flex justify-content-start">
                                        <div>{{detailUjian.view_type}}</div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-lg-8 d-flex justify-content-between">
                                        <div> <strong>Tenggat Waktu</strong></div>
                                        <span>:</span>
                                    </div>
                                    <div class="col-lg-4 d-flex justify-content-start">
                                        <div>{{detailUjian.view_date}}</div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-6">
                                <div class="row">
                                    <div class="col-lg-8 d-flex justify-content-between">
                                        <div> <strong>Durasi</strong></div>
                                        <span>:</span>
                                    </div>
                                    <div class="col-lg-4 d-flex justify-content-start">
                                        <div>{{detailUjian.duration}} Menit</div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-lg-8 d-flex justify-content-between">
                                        <div> <strong>Kode Ujian</strong></div>
                                        <span>:</span>
                                    </div>
                                    <div class="col-lg-4 d-flex justify-content-start">
                                        <div>{{detailUjian.code}}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-if="detailUjian.task_status == '1'" class="card-footer d-flex justify-content-end">
                            <square-loader :loading="showStartUjianLoader" :color="'#ca062a'" :size="'30px'"></square-loader>
                            <b-button v-if="!showStartUjianLoader" variant="primary" size="sm" style="width: 15%;" @click="startUjian">Mulai Ujian</b-button>
                        </div>
                    </card>
                    <br>
                    <card v-if="detailUjian.task_status == '2'" header-classes="bg-transparent" body-classes="bg-transparent p-0">
                        <div slot="header" class="align-items-center">
                            Soal Ujian
                        </div>
                        <div v-if="detailUjian.is_file==1" class="card-body">
                            <div v-if="detailUjian.file_type=='video'">
                                <video-embed :src="detailUjian.file_path"></video-embed>
                            </div>
                            <div v-else style="text-align:center">
                                <iframe :src="detailUjian.view_link" width="100%" height="500"></iframe>
                            </div>
                        </div>
                        <div v-else class="card-body" v-html="detailUjian.description"></div>
                        <div class="card-body">
                            <div class="jawaban">
                                <b-form data-vv-scope="ujian-form">
                                    <wysiwyg
                                        id="ujian_input"
                                        name="ujian_input"
                                        data-vv-as="Jawaban"
                                        v-model="do_task_form.answer"
                                        type="text"
                                        placeholder="Jawaban"
                                        v-validate="'required'"
                                        autocomplete="off"
                                    />
                                    <span :class="{ 'error-validation': errors.first('ujian-form.ujian_input') }">{{ errors.first('ujian-form.ujian_input') }}</span>
                                </b-form>
                            </div>
                        </div>
                        <div class="card-footer d-flex justify-content-end">
                            <square-loader :loading="showLoader" :color="'#ca062a'" :size="'30px'"></square-loader>
                            <b-button v-if="!showLoader" variant="primary" size="sm" style="width: 15%;" @click="selesaiUjian">Selesai</b-button>
                        </div>
                    </card>
                </div>
                <div class="col-xl-4">
                    <div class="card" >
                        <div class="card-header row align-items-center bg-transparent">
                            <div class="col">
                                <h6 class="text-uppercase ls-1 mb-1">Waktu</h6>
                            </div>
                        </div>
                        <div class="card-body">
                            <div class="card">
                                <div class="card-body text-center">
                                    <div class="outer-container">
                                        <div class="inner-container">
                                            <div class="countdown text-center">
                                                <h2 v-if="detailUjian.task_remaining && detailUjian.task_status == '2'">{{ timeLeft }}</h2>
                                                <h2 v-else>{{ duration }}</h2>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import SquareLoader from 'vue-spinner/src/SquareLoader.vue'
    export default {
        components: {
            SquareLoader
        },
        data() {
            return {
                showStartUjianLoader: false,
                showLoader: false,
                selectedTime: 0,
                timeLeft: '00:00:00',
                duration: '00:00:00',
                endTime: '0',
                secondsLeft: 0,
                times: [
                    {
                        sec: 3,
                        display: '3s'
                    },
                    {
                        sec: 600,
                        display: ' 10m'
                    },
                    {
                        sec: 5000,
                        display: '30m'
                    }
                ],
                token: this.$route.params.token,
                detailUjian: {},
                do_task_form: {
                    task_id : null,
                    answer : null,
                    duration : null
                }
            }
        },
        watch: {
            secondsLeft(newVal) {
                if (newVal == 0) {
                    this.$swal.fire({
                        title: 'Perhatian!',
                        text: 'Waktu pengerjaan soal telah habis!',
                        icon: 'warning',
                        showCancelButton: false,
                        confirmButtonColor: '#3085d6',
                        cancelButtonColor: '#d33',
                        confirmButtonText: 'OK',
                    }).then(() => {
                        let scope = 'ujian-form'
                        this.doingTask(scope)
                    })
                }
            },
        },
        methods: {
			async getSoalUjian() {
                let taskToken = this.token
				await this.$store.dispatch('getSoalUjian', { taskToken })
					.then( async (res) => {
                        this.detailUjian = res.data.data
                        let duration = this.convertTime(this.detailUjian.duration)
                        let menit = duration.menit.toString().length == 1 ? 0+Math.floor(duration.menit) : Math.floor(duration.menit)
                        this.duration = Math.floor(duration.jam)+':'+menit+':00'
                        if (typeof this.detailUjian.task_remaining != 'undefined') {
                            if (this.detailUjian.task_remaining > 0) {
                                await this.countdown(this.detailUjian.task_remaining, true)
                                await this.setTime(this.detailUjian.task_remaining)
                            } else {
                                this.$swal.fire({
                                    title: 'Perhatian!',
                                    text: 'Waktu pengerjaan soal telah habis!',
                                    icon: 'warning',
                                    showCancelButton: false,
                                    confirmButtonColor: '#3085d6',
                                    cancelButtonColor: '#d33',
                                    confirmButtonText: 'OK',
                                }).then(() => {
                                    let scope = 'ujian-form'
                                    this.doingTask(scope)
                                })
                            }
                        }
					})
					.catch((err)=> {
                        this.$swal.fire({
                            title: 'Failed',
                            text: err.response.data.message,
                            icon: 'warning',
                            showCancelButton: false,
                            confirmButtonColor: '#3085d6',
                            cancelButtonColor: '#d33',
                            confirmButtonText: 'OK',
                        }).then(() => {
                            this.$router.push({ name: 'dashboard' })
                        })
					})
            },
			async doUjian() {
                let id = this.detailUjian.id
                this.showStartUjianLoader = true
				await this.$store.dispatch('doUjian', { id })
					.then(() => {
                        this.showStartUjianLoader = false
                        this.getSoalUjian()
					})
					.catch((err)=> {
                        this.showStartUjianLoader = false
						this.$swal.fire('Failed', err.response.data.message, 'error')
					})
            },
            async startUjian() {
                this.$swal.fire({
                    title: 'Apakah anda yakin akan memulai ujian?',
                    text: 'waktu ujian akan otomatis berjalan setelah anda memulai ujian',
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Ya, saya yakin',
                    cancelButtonText: 'Tidak'
                }).then((result) => {
                    if (result.value) {
                        this.doUjian()
                    }
                })
            },
            async selesaiUjian() {
                let scope = 'ujian-form'
                this.$validator.validateAll(scope).then(valid => {
                    if (valid) {
                        this.$swal.fire({
                            title: 'Apakah anda yakin akan selesai ujian?',
                            text: '',
                            icon: 'warning',
                            showCancelButton: true,
                            confirmButtonColor: '#3085d6',
                            cancelButtonColor: '#d33',
                            confirmButtonText: 'Ya, saya yakin',
                            cancelButtonText: 'Tidak'
                        }).then((result) => {
                            if (result.value) {
                                this.doingTask(scope)
                            }
                        })
                    }
                });
            },
            async doingTask(scope) {
                this.showLoader = true
                this.do_task_form.task_id = this.detailUjian.id
                this.do_task_form.duration = this.detailUjian.duration
                let form = this.do_task_form
                this.$store.dispatch('doingTask', form)
                    .then((res) => {
                        this.showLoader = false
                        this.$swal.fire({
                            title: 'Success',
                            text: res.message,
                            icon: 'success',
                            showCancelButton: false,
                            confirmButtonColor: '#3085d6',
                            cancelButtonColor: '#d33',
                            confirmButtonText: 'OK',
                        }).then(() => {
                            this.$router.push({ name: 'modul-task', params: { modulId: this.detailUjian.learning_activity_id }  })
                        })
                    })
                    .catch((err)=> {
                        let error = err.response
                        this.showLoader = false
                        if (error.status == 400) {
                            this.errorValidate(error.data, scope)
                        } else {
                            this.$swal.fire('Failed', error.data.message, 'error')
                        }
                    })
            },
            setTime(seconds) {
                this.secondsLeft = seconds
                this.timer()
            },
            timer() {
                const now = Date.now();
                const end = now + this.secondsLeft * 1000;
                this.displayTimeLeft(this.secondsLeft);

                this.selectedTime = this.secondsLeft;
                this.countdown(end);
            },
            countdown(end, clear = false) {
                var myInterval;
                if (!clear) {
                    myInterval = setInterval(() => {
                        this.secondsLeft = Math.round((end - Date.now()) / 1000);
    
                        if(this.secondsLeft === 0) {
                            this.endTime = 0;
                        }
    
                        if(this.secondsLeft < 0) {
                            return;
                        }
                        this.displayTimeLeft()
                    }, 1000);
                }
                if (clear && myInterval) {
                    clearInterval(myInterval);
                }
            },
            displayTimeLeft() {
                const hours = Math.floor((this.secondsLeft / 3600));
                const minutes = Math.floor((this.secondsLeft % 3600) / 60);
                const seconds = this.secondsLeft % 60;

                this.timeLeft = `${zeroPadded(hours)}:${zeroPadded(minutes)}:${zeroPadded(seconds)}`;
            },
            convertTime(value) {
                let x = value*60
                let y     = x % 3600;
                let jam   = x / 3600;
                let menit = y / 60;
                let detik = y % 60;
                
                let result = {
                    'jam' : jam,
                    'menit' : menit,
                    'detik' : detik
                }
                return result

                // result.innerHTML = Math.floor(jam) + ' Jam ' + Math.floor(menit) + ' Menit ' + Math.floor(detik) + ' Detik ';
            }
        },
        async created() {
            await this.getSoalUjian()
        }
    }
    function zeroPadded(num) {
    // 4 --> 04
    return num < 10 ? `0${num}` : num;
    }
</script>